import { createQuery } from "react-query-kit";
import { generatePath } from "react-router-dom";

import type { IQueryVariablesType } from "./types";
import { dropdownURLs } from "./path";

import type { AxiosError, IApiResponse, IAxiosFn } from "@api/types";
import { axiosClient } from "@/api/clients";
import type { IOption } from "@/interfaces";
import type { ID } from "@/constants";

const key = "options";

type IResponse = IApiResponse<IOption<ID>[]>;
type IVariables = IQueryVariablesType;

export const getOptions: IAxiosFn<IVariables, IResponse> = async (
  props,
  signal,
) => {
  const { optionType, params, queryParam } = props;
  const url = generatePath(dropdownURLs[optionType], params);

  const { data } = await axiosClient.get(url, {
    params: queryParam,
    signal,
  });

  return data;
};

export const useOptions = createQuery<IResponse, IVariables, AxiosError>({
  primaryKey: key,
  queryFn: ({ queryKey: [_primaryKey, variables], signal }) =>
    getOptions(variables, signal),
});
